__turbopack_context__.v({
  "h2": "StyleComponents-module__Qi08Za__h2",
  "h3": "StyleComponents-module__Qi08Za__h3",
  "p": "StyleComponents-module__Qi08Za__p",
});
